<div class="contentMain">
  <!-- breadcrumb -->
  <div class="row">
    <div class="col-md-12 card-header mainheader header-container">
      <h5>Charges</h5>
    </div>
    <!-- <div class="col-md-6 ">
            <ol class="breadcrum d-flex justify-content-end">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">Branch Creation</li>
            </ol>
        </div> -->
  </div>
  <!--/ breadcrumb-->
  <!-- main body -->
  <main class="row">
    <!-- card -->
    <div class="card">
      <div class="card-body">
        <!-- bootstrap tabs -->
        <div class="kliqtab">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs p-0 mb-3">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="tab" href="#General"
                >General</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#StockPoint">GST</a>
            </li>
          </ul>
          <!-- Tab panes -->
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane in active p-3" id="General">
              <!-- general -->
              <!--/ row -->
              <div class="card-body">
                <!-- row -->
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div class="d-flex">
                      <p class="pb-0 mb-0">Status</p>
                      <div class="checkbox ml-3">
                        <input id="activestatus" type="checkbox" />
                        <label for="activestatus"> Active </label>
                      </div>
                    </div>
                  </div>
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <div class="form-group">
                        <label>Charge Name</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="charge Name"
                        />
                      </div>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <div class="form-group">
                        <label>Charge Higher</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="charge Code"
                        />
                      </div>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <div class="form-group">
                        <label>Charge Type</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Charge Type"
                        />
                      </div>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label> Charge Style</label>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Charge Style"
                      >
                        <option>Select Under</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Charge Rate</label>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Charge Rate"
                      >
                        <option>Select Rate</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Charge Calc on</label>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Charge Calc on"
                      >
                        <option>Select Charge</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <div class="form-group">
                      <label>Account Name</label>
                      <select
                        class="form-control show-tick ms select2"
                        data-placeholder="Account Name"
                      >
                        <option>Select Account</option>
                        <option>Select Item1</option>
                        <option>Select Item2</option>
                        <option>Select Item3</option>
                        <option>Select Item4</option>
                      </select>
                    </div>
                  </div>
                  <!--/ col -->
                  <!-- col -->

                  <!--/ col -->
                </div>
                <!-- /row -->
              </div>
              <!--/ row -->
              <!--/ general -->
            </div>
            <div role="tabpanel" class="tab-pane p-3" id="StockPoint">
              <!-- Stock point -->
              <div class="row">
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <h4>GST Tax Rates</h4>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>2.50</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 mt-4">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <button>GST</button>
                  </div>
                </div>
                <!--/ col -->
              </div>
              <!--/ row -->
              <!-- row-->
              <div class="row">
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>CGST %</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>2.50</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>CGST Input 2.5%</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>CGST Output 2.5%</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
              </div>
              <!--/ row -->
              <!-- row-->
              <div class="row">
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>SGST %</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>2.50</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>CGST Input 2.5%</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>CGST Output 2.5%</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
              </div>
              <!--/ row -->
              <!-- row-->
              <div class="row">
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>IGST %</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>2.50</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>CGST Input 2.5%</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>CGST Output 2.5%</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
              </div>
              <!--/ row -->
              <!-- row-->
              <div class="row">
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <div class="form-group">
                      <label>CESS %</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="CESS"
                      />
                    </div>
                  </div>
                </div>
                <!--/ col -->
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>Select</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
                <!-- col -->
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <select
                      class="form-control show-tick ms select2"
                      data-placeholder="Select"
                    >
                      <option>Select</option>
                      <option>Select Item1</option>
                      <option>Select Item2</option>
                      <option>Select Item3</option>
                      <option>Select Item4</option>
                    </select>
                  </div>
                </div>
                <!--/ col -->
              </div>
              <!--/ Stock Points -->
            </div>
          </div>
        </div>
        <!--/ bootstrap tabs -->
      </div>
      <div class="card-footer text-left w-100">
        <button class="btn redbtn" type="button">F3-Save</button>

        <button class="btn redbtn" type="button">Clear</button>
        <button class="btn redbtn" type="button">Cancel</button>

        <button class="btn redbtn" type="button">Help</button>
      </div>
    </div>
    <!--/ card -->
  </main>
  <!-- main body -->
</div>
